require('./bootstrap');
const max_prod_count = 20;
const max_service_count = 6;
const max_gallery_count = 10;

jQuery.fn.extend({
    scrollToMe: function () {
        var x = jQuery(this).offset().top - 100;
        jQuery('html,body').animate({
            scrollTop: x
        }, 500);
    }
});
(function () {
    var form_loaded = false;
    /**
     * Select template page
     */
    if ($('.template-slider').length) {
        require('slick-carousel');

        var status = $('.pagingInfo');
        var slickElement = $('.template-slider');
        var gotoThirdButton = $('.template-select-btn');
        var gotoThirdUrl = gotoThirdButton.attr('href');

        /**
         * adding count and nav button logic
         */
        slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            status.text(i + '/' + slick.slideCount);

            if (i === slick.slideCount) {
                $('.template-next-btn').addClass('hidden');
            } else {
                $('.template-next-btn').removeClass('hidden');
            }
            if (i - 1 === 0) {
                $('.template-prev-btn').addClass('hidden');
            } else {
                $('.template-prev-btn').removeClass('hidden');
            }
        });

        /**
         * initialize slick slider
         */
        slickElement.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            donts: false,
            infinite: false,
            centerMode: true,
            centerPadding: '70px',
            prevArrow: $('.template-prev-btn'),
            nextArrow: $('.template-next-btn'),
            responsive: [{
                breakpoint: 480,
                settings: {
                    centerPadding: '50px',
                }
            }]
        });

        function disableSlick(hold) {
            slickElement.slick("slickSetOption", "accessibility", hold);
            slickElement.slick("slickSetOption", "draggable", hold);
            slickElement.slick("slickSetOption", "swipe", hold);
            slickElement.slick("slickSetOption", "touchMove", hold);
        }

        /**
         * on slide click
         */
        $(document).on('click', '.template-slider .slick-slide', function (e) {

            var slickIndex = $(this).attr('data-slick-index');
            var selectedTemplateItem = $(e.currentTarget).find('.template-item');
            let selectedTemplateItemID = selectedTemplateItem.attr("data-template-id");
            slickElement.slick('slickUnfilter');
            if ($('.selected-template').length) {
                disableSlick(true)
                gotoThirdButton.removeClass('selected');
                slickElement.find('.template-item').removeClass('selected-template');
                $('main').removeClass('template-is-selected');
                $('body').removeClass('template-is-selected-body');
                gotoThirdButton.attr('href', '#');
            } else {
                disableSlick(false)
                $('main').addClass('template-is-selected');
                $('body').addClass('template-is-selected-body');
                selectedTemplateItem.addClass('selected-template');
                slickElement.slick('slickGoTo', slickIndex);
                gotoThirdButton.addClass('selected');
                gotoThirdButton.attr('href', gotoThirdUrl + '?design_template=' + selectedTemplateItemID);

                if (typeof previous_url !== "undefined") {
                    var newHref = gotoThirdButton.attr('href') + '&edit_url=' + encodeURIComponent(previous_url)
                    gotoThirdButton.attr('href', newHref);
                    localStorage.setItem('pm_tribe_design_template', selectedTemplateItemID)
                }
            }
        });

        $(document).on('click', '.deselect-design', function () {
            $('.template-slider .selected-template').trigger('click')
        });
    }

    /**
     * Text-area count
     */
    $('textarea').on('input', function () {
        var current = $(this).parents('.form__group').find('.current');
        current.text($(this).val().length);
    });

    /**
     * page name sanitization
     */
    $('#page_name').on('input', function () {
        $('.success-message').hide()
        var s = this.value
        this.value = _.trim(s).toLowerCase();

        $('#generate-link-btn').addClass('btn-disable');
        $('.second-step .success-message').hide();
        toggle_second_step()
    });
    /**
     * Disable enter on page-name
     */
    $('#page_name').on('keydown', function (e) {
        if (e.key == "Enter") e.preventDefault();
        if (e.key == "Enter") return false;
    });

    /**
     * adding https://
     */
    $('#website').on('focus', function () {

        var val = $(this).val();

        if (val.length == 0) {

            $(this).val('https://')
        }
    });

    /**
     * removing https://
     */
    $('#website').on('blur', function () {

        var val = $(this).val();

        if (val == 'https://') {

            $(this).val('')
        }
    })

    /**
     * Preview btn text toggle and position
     */
    if ($('.preview-btn').length) {

        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 40) {
                $('.preview-btn span').hide()
            } else {
                $('.preview-btn span').show()
            }
        });

        $(window).on('load', previewPosition)
        $(window).on('resize', previewPosition)

        function previewPosition() {
            $vWidth = $(this).width();
            if ($vWidth > 480) {
                $('.preview-btn').css('right', $('main').offset().left + 15)
            } else {
                $('.preview-btn').css('right', 20)
            }
        }
    }

    function addImageRemoveIcon(name) {
        var remove_image_src = $('#remove_image_src').text();
        var added = '<span data-name="' + name + '" class="image_remove_icon image_remove_icon_' + name + '"><img src="' + remove_image_src + '"></span>';
        $('#' + name).after(added)
    }

    $(document).on('click', '.image_remove_icon', function () {
        var clicked = $(this);
        $.confirm({
            title: 'Are You Sure?',
            content: 'Do You Really Want To Delete This Image.',
            closeIcon: true,
            animation: 'opacity',
            closeAnimation: 'opacity',
            animationSpeed: 0,
            columnClass: 'col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1',
            buttons: {
                cancel: {
                    text: 'NO',
                    btnClass: 'confirm-no',
                },
                confirm: {
                    text: 'YES',
                    btnClass: 'confirm-yes',
                    action: function () {
                        var default_image = $('#default_image').text();
                        var name = clicked.attr('data-name');
                        var preview = $("#" + name).prevAll('.form__label_upload_image').find('img');
                        preview.attr('src', default_image)
                        $('#' + name).val('').trigger('change');
                        $('#name').val($('#name').val() + ' ').trigger('change')
                        $('#name').val($('#name').val().trim()).trigger('change')

                        clicked.remove();
                    },
                },

            }
        });
    });

    /**
     * Croping things
     */
    if ($('#crop_image').length) {

        /**
         * different cropper data for diff inputs/images
         */

        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                var default_image = $('#default_image').text();
                var image_input = ['logo_image', 'profile_pic_image', 'qr_code_image'];
                $.each(image_input, function (index, element) {
                    var preview = $("[name='" + element + "']").prevAll('.form__label_upload_image').find('img');
                    var added = $("[name='" + element + "']").nextAll('.image_remove_icon').length;
                    if (preview.attr('src') != default_image && !added) {
                        addImageRemoveIcon(element);
                    }
                });

                clearInterval(add_imageIcons);
            }

        }, 200)

        var $logo_image_dimens = {
            width: 414,
            height: 180
        }
        var $logo = {
            aspectRatio: 2.3,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: true,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($logo_image_dimens)
            }
        }
        var $profile_pic_image_dimens = {
            width: 200,
            height: 200
        }
        var $profile_pic = {
            aspectRatio: 1,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: false,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($profile_pic_image_dimens)
            }
        }
        var $qr_code_image_dimens = {
            width: 200,
            height: 200
        }
        var $qr_code = {
            aspectRatio: 1,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: false,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($qr_code_image_dimens)
            }
        }

        var $prod_image_dimens = {
            width: 200,
            height: 200
        }
        var $prod_image = {
            aspectRatio: 1,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: false,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($qr_code_image_dimens)
            }
        }

        var $service_image_dimens = {
            width: 308,
            height: 160
        }
        var $service_image = {
            aspectRatio: 1.93,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: false,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($qr_code_image_dimens)
            }
        }

        var $galler_image_dimens = {
            width: 400,
            height: 400
        }
        var $galler_image = {
            aspectRatio: 1,
            dragMode: 'move',
            cropBoxResizable: false,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            toggleDragModeOnDblclick: false,
            ready() {
                cropper.zoomTo(.5);
                $("#crop_zoom").val(.5);
                $("#crop_zoom").trigger('click');
                // cropper.setCropBoxData($qr_code_image_dimens)
            }
        }

        var $modal = $('#image_crop_modal');
        var crop_image = $('#crop_image');
        var cropper;
        var selectedInputId;
        var SelectedInputCropperObject;
        var Selected_image_dimens;

        /**
         * Handle image input change
         */
        $(document).on('change', '.form__input_upload', function (e) {

            var input = $(this);

            var files = e.target.files;
            var done = function (url) {
                input.val('');
                crop_image.attr('src', url);
                showModal(input);
            };
            var reader;
            var file;

            if (files && files.length > 0) {
                file = files[0];
                File_name = file.name;
                File_type = file.type;
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }

        });

        /**
         *
         * Show modal and set cropper object and selected input
         */
        function showModal(input) {

            selectedInputId = input.attr('id');
            if (selectedInputId == 'logo') {
                SelectedInputCropperObject = $logo;
                Selected_image_dimens = $logo_image_dimens;
            } else if (selectedInputId == 'profile_pic') {
                SelectedInputCropperObject = $profile_pic;
                Selected_image_dimens = $profile_pic_image_dimens;
            } else if (selectedInputId == 'qr_code') {
                SelectedInputCropperObject = $qr_code;
                Selected_image_dimens = $qr_code_image_dimens;
            } else if (input.hasClass('prod_image_input')) {
                SelectedInputCropperObject = $prod_image;
                Selected_image_dimens = $prod_image_dimens;
            } else if (input.hasClass('service_image_input')) {
                SelectedInputCropperObject = $service_image;
                Selected_image_dimens = $service_image_dimens;
            } else if (input.hasClass('gallery_item_image_input')) {
                SelectedInputCropperObject = $galler_image;
                Selected_image_dimens = $galler_image_dimens;
            }
            $modal.modal('show');
        }


        /**
         * After modal is shown init cropper
         */
        $modal.on('shown.bs.modal', function () {
            cropper = new Cropper(crop_image[0], SelectedInputCropperObject);
        }).on('hidden.bs.modal', function () {
            if (cropper)
                cropper.destroy();
            cropper = null;
        });

        /**
         * on crop button click
         */
        $('#crop_image_btn').on('click', function () {
            var canvas = cropper.getCroppedCanvas(Selected_image_dimens);

            var preview = $("#" + selectedInputId).prev('.form__label_upload_image').find('img');
            // preview.attr('src',  canvas.toDataURL())
            canvas.toBlob(function (blob) {
                new Compressor(blob, {
                    quality: .8,
                    convertSize: 0,
                    success(result) {
                        var reader = new FileReader();
                        reader.onload = function () {
                            preview.attr('src', (reader.result))
                            $('#' + selectedInputId + '_image').val(reader.result).trigger('change');
                            $('#name').val($('#name').val() + ' ').trigger('change')
                            $('#name').val($('#name').val().trim()).trigger('change')
                            addImageRemoveIcon(selectedInputId + '_image');
                        };
                        reader.readAsDataURL(result);
                    }
                });
            });
            $modal.modal('hide');
        });


        /**
         * Zoom controls
         */
        $(".crop_zoom_minus").on('click', function (event) {
            zoom("out");
        });

        $(".crop_zoom_plus").on('click', function (event) {
            zoom("in");
        });

        $("#crop_zoom").on('input change', function (event) {
            var zoomValue = parseFloat($(event.currentTarget).val());
            if (cropper)
                cropper.zoomTo(zoomValue.toFixed(2));
        });

        function zoom(direction) {
            var slider = $("#crop_zoom");
            var step = parseFloat(slider.attr('step'), 10);
            var currentSliderValue = parseFloat(slider.val(), 10);
            var newStepValue = currentSliderValue + step;

            if (direction === "out") {
                newStepValue = currentSliderValue - step;
            } else {
                newStepValue = currentSliderValue + step;
            }
            slider.val(newStepValue).trigger('change');
        };

        document.getElementById("crop_zoom").oninput = function () {
            var value = (this.value - this.min) / (this.max - this.min) * 100
            this.style.background = 'linear-gradient(to right, #fff 0%, #fff ' + value + '%, #777 ' + value + '%, #777 100%)'
        };

    }

    /**
     * Styling submit btn based on required fields
     */
    $(document).on('change input', '#user_creation_form .form__input[required]', function () {
        $('#user_creation_form').find('.form__input[required]').each(function () {
            // if ($(this).prop('required')) {
            $('.submit-btn').removeClass('active');
            if ($(this).val() == "") return false;
            $('.submit-btn').addClass('active');
            // }
        });
    });

    /**
     * Form submission handling
     */
    // $('.create-your-url').on('click', function (e) {
    $('#user_creation_form').on('submit', function (e) {
        storeFormToStorage($('#user_creation_form'), 'Partial');
        e.preventDefault();

        get_recaptcha_token('handle_user_creation').then(function (token) {
            toggle_second_step();
            var data = $('#user_creation_form').serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});
            data['unique_id'] = get_pm_tribe_me_id();
            data['recaptcha'] = token;
            $.ajax({
                url: $('#user_creation_form').attr('action'),
                type: 'POST',
                data: data,
                beforeSend: function () {
                    $('.loader-holder').fadeIn(500)
                },
                complete: function () {
                    $('.loader-holder').fadeOut(500)
                },
                success: function (res) {
                    if (res.current_form_step == 0) {
                        if (res.goto_second_step) {
                            goto_second_step();
                        } else {
                            goto_first_step();
                            printErrorMsg(res.error, 1);
                        }
                    } else if (res.current_form_step == 1 || res.current_form_step == 2) {
                        goto_second_step();
                        printErrorMsg(res.error, 2);
                    }
                }
            });
        });
    });

    /**
     * goto_first_step
     */
    function goto_first_step() {
        // window.location = '/add?design_template=' + $('#design_template').val();
        $('.preview-btn').removeClass('perma-small')
        $('.invalid').removeClass('invalid')
        $(".second-step .error-message").hide();
        $(".second-step .error-message").find("ul").html('');
        $('.first-step').show();
        $('.second-step').hide();
        $('#page_name').attr('required', false);
        toggle_second_step()
        $('.top-text span').text('Add Information')
        $('.top-text .back-btn').hide()
        $('.show-selected-design').show()
    }

    /**
     * goto_second_step
     */
    function goto_second_step() {
        window.location = '/generate?design_template=' + $('#design_template').val();
        $('.preview-btn').addClass('perma-small')
        $('.invalid').removeClass('invalid')
        $(".first-step .error-message").hide();
        $(".first-step .error-message").find("ul").html('');
        $('.second-step').show();
        $('.first-step').hide();
        $('#page_name').attr('required', true);
        $('#page_name').val(_.kebabCase($('#name').val())).trigger('change')
        $('#page_name').scrollToMe();
        $('#page_name').trigger('focus');
        toggle_second_step()
        $('.top-text span').text('Generate URL')
        $('.top-text .back-btn').show()
        $('.show-selected-design').hide()
    }

    /**
     * show 5th screen
     */
    function allow_profile_creation() {
        $('.second-step .success-message').show();
        $('.invalid').removeClass('invalid')
        $('.second-step .error-message').hide();
        $('.second-step .error-message').find('ul').html('');
        $('#generate-link-btn').removeClass('btn-disable')
    }

    /**
     * checking url availability
     */
    $('#check_url_availability_btn').on('click', function (e) {
        storeFormToStorage($('#user_creation_form'), 'PartialWithLink');
        e.preventDefault();
        get_recaptcha_token('handle_user_creation').then(function (token) {
            toggle_second_step();
            var data = $('#user_creation_form').serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});
            data['unique_id'] = get_pm_tribe_me_id();
            data['recaptcha'] = token;
            $.ajax({
                url: $('#user_creation_form').attr('action'),
                type: 'POST',
                data: data,
                beforeSend: function () {
                    $('.loader-holder').fadeIn(500)
                },
                complete: function () {
                    $('.loader-holder').fadeOut(500)
                },
                success: function (res) {
                    if (res.url_available) {
                        allow_profile_creation()
                    } else {
                        $('#generate-link-btn').addClass('btn-disable')
                        printErrorMsg(res.error, 2);
                    }
                }
            });
        });
    });

    /**
     * generate link btn click handling
     */
    $('#generate-link-btn').on('click', function (e) {
        storeFormToStorage($('#user_creation_form'), 'Partial');
        e.preventDefault();
        get_recaptcha_token('handle_user_creation').then(function (token) {
            toggle_second_step();
            $('#form_step').val(2)
            var data = $('#user_creation_form').serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});
            data['unique_id'] = get_pm_tribe_me_id();
            data['recaptcha'] = token;
            $.ajax({
                url: $('#user_creation_form').attr('action'),
                type: 'POST',
                data: data,
                beforeSend: function () {
                    $('.loader-holder').fadeIn(500)
                },
                complete: function () {
                    $('.loader-holder').fadeOut(500)
                },
                success: function (res) {

                    if (res.redirect_url) {
                        window.location.href = res.thank_you_url;
                    } else {
                        $('#generate-link-btn').addClass('btn-disable');
                        printErrorMsg(res.error, 2);
                    }
                }
            });
        });
    });

    /**
     * toggle_second_step
     */
    function toggle_second_step() {
        if ($('.first-step').css('display') == 'block') {
            $('#form_step').val(0)
        } else if ($('.second-step').css('display') == 'block') {
            $('#form_step').val(1)
        }
    }

    /**
     * Show validation errors
     */
    function printErrorMsg(msg, step) {
        $error_holder = (step == 1) ? $('.first-step .error-message') : $('.second-step .error-message')
        $('.field-info').find('.error-message').remove();
        $('.field-info').not('.og').addClass('empty')
        $error_holder.find("ul").html('');
        $error_holder.show();
        $('.invalid').removeClass('invalid');
        var didIt = false;
        $.each(msg, function (key, value) {
            if (!didIt) {
                if (key != 'recaptcha') {
                    if (key.indexOf('dynamic_products.') > -1) {
                        index = key.substring(
                            key.indexOf(".") + 1,
                            key.lastIndexOf("."));
                        var elem = key.split(".").pop();
                        var parent = $('[name="dynamic_products[' + index + '][' + elem + ']"]').parents('.dynamic-product');

                        if (parent.find('.' + elem + '_input').length) {
                            parent.find('.' + elem + '_input').scrollToMe();
                            parent.find('.' + elem + '_input').trigger('focus');
                            parent.find('.' + elem + '_input').addClass('invalid');
                            parent.find('.' + elem + '_input').nextAll('.field-info').removeClass('empty').prepend('<div class="error-message">' + value.join(' <br>') + '</div>');
                            didIt = true;
                        } else {
                            if (parent.length) {
                                parent.scrollToMe();
                                parent.find('.form__label_upload_image').addClass('invalid')
                            }
                        }
                    } else if (key.indexOf('dynamic_services.') > -1) {
                        index = key.substring(
                            key.indexOf(".") + 1,
                            key.lastIndexOf("."));
                        var elem = key.split(".").pop();
                        var parent = $('[name="dynamic_services[' + index + '][' + elem + ']"]').parents('.dynamic-service');

                        if (parent.find('.' + elem + '_input').length) {
                            parent.find('.' + elem + '_input').scrollToMe();
                            parent.find('.' + elem + '_input').trigger('focus');
                            parent.find('.' + elem + '_input').addClass('invalid');
                            parent.find('.' + elem + '_input').nextAll('.field-info').removeClass('empty').prepend('<div class="error-message">' + value.join(' <br>') + '</div>');
                            didIt = true;
                        } else {
                            if (parent.length) {
                                parent.scrollToMe();
                                parent.find('.form__label_upload_image').addClass('invalid')
                            }
                        }
                    } else if (key.indexOf('dynamic_gallery.') > -1) {
                        index = key.substring(
                            key.indexOf(".") + 1,
                            key.lastIndexOf("."));
                        var elem = key.split(".").pop();
                        var parent = $('[name="dynamic_gallery[' + index + '][' + elem + ']"]').parents('.dynamic-gallery-item');
                        if (parent.length) {
                            parent.scrollToMe();
                            parent.find('.form__label_upload_image').addClass('invalid')
                        }
                    } else {

                        $('#' + key).scrollToMe();
                        $('#' + key).trigger('focus');
                        didIt = true;
                    }
                }
            }
            $('#' + key).addClass('invalid');
            $('#' + key).nextAll('.field-info').removeClass('empty').prepend('<div class="error-message">' + value.join(' <br>') + '</div>')

            if (step == 1) {
                if (key == 'recaptcha')
                    $error_holder.find("ul").append('<li>Recaptcha: ' + value.join(' <br>') + '</li>');
            } else {
                $error_holder.find("ul").append('<li>' + value.join(' <br>') + '</li>');
            }
        });
    }

    /**
     * On preview btn click action
     */
    $('#preview-btn').on('click', function () {
        var has_val = 0;
        if ($('#user_creation_form').length) {
            var $form = $('#user_creation_form');
        } else {
            var $form = $('#user_update_form')
        }
        $form.find('.form__input').each(function () {
            has_val += $(this).val() != "";
        });

        var url = new URL(design_template_path);
        var ignore = ['logo_image', 'profile_pic_image', 'qr_code_image'];
        var emptyImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
        emptyImage = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
        var logo_image_val = $('#logo_image').val();
        var profile_pic_image_val = $('#profile_pic_image').val();
        var qr_code_image_val = $('#qr_code_image').val();
        var prodImages = [];
        var ServiceImages = [];
        var GalleryImages = [];
        for (var item of $form.serializeArray()) {
            if (ignore.includes(item.name)) {
                if ($('#' + item.name).val())
                    url.searchParams.set(item.name, emptyImage)
            } else {
                if (item.name.indexOf('prod_image_hidden') > -1) {
                    url.searchParams.set(item.name, emptyImage);
                    prodImages.push(item.value);
                } else if (item.name.indexOf('service_image_hidden') > -1) {
                    url.searchParams.set(item.name, emptyImage);
                    ServiceImages.push(item.value);
                } else if (item.name.indexOf('gallery_item_image_hidden') > -1) {
                    url.searchParams.set(item.name, emptyImage);
                    GalleryImages.push(item.value);
                } else {
                    url.searchParams.set(item.name, item.value)
                }
            }
        }

        $("#pdf-preview-iframe").html("<iframe id='previewiframe' frameborder=0 src='" + url + "'></iframe>")
        var previewiframe = $("#previewiframe");

        previewiframe.on('load', function () {
            setTimeout(function () {
                if (logo_image_val) {
                    previewiframe.contents().find('#logo-pic').attr('src', logo_image_val)
                }
                if (profile_pic_image_val) {
                    previewiframe.contents().find('#profile-pic-img').attr('src', profile_pic_image_val)
                }
                if (qr_code_image_val) {
                    previewiframe.contents().find('#qrimage').attr('src', qr_code_image_val)
                }
                if (prodImages.length > 0) {
                    $.each(prodImages, function (index, value) {
                        previewiframe.contents().find('.product_col').eq(index).find('.prod_img img').attr('src', value);
                    });
                }
                if (ServiceImages.length > 0) {
                    $.each(ServiceImages, function (index, value) {
                        previewiframe.contents().find('.service_col').eq(index).find('.service_img img').attr('src', value);
                    });
                }
                if (GalleryImages.length > 0) {
                    $.each(GalleryImages, function (index, value) {
                        if (index == 0) {
                            previewiframe.contents().find('.pbi-img').find('img').attr('src', value);
                        }
                        previewiframe.contents().find('.pbi-slide-img:not(.blank)').eq(index).find('img').attr('src', value);
                    });
                }
                if (has_val == 0) {

                    var empty_preview = $('<div/>', {
                        id: 'empty_preview',
                        html: 'Once you start updating your design you can see those changes here.',
                        css: {
                            'margin': 'auto',
                            'padding': '70px 50px',
                            'font': 'normal normal normal 16px/20px Source Sans Pro',
                        }
                    });

                    previewiframe.contents().find('.container').append(empty_preview)
                }

                if (window.innerWidth > 480) {
                    previewiframe.width(previewiframe.contents().width());
                } else {
                    previewiframe.width('100%');
                }

                previewiframe.height(previewiframe.contents().height());

            }, 100);
        });

        $('#preview_modal').modal('show');

    });

    if ($('.top-text .back-btn').length) {
        $(document).on('click', '.top-text .back-btn', function (e) {
            e.preventDefault();
            window.location = '/add?design_template=' + $('#design_template').val();
            // if ($('#form_step').val() != 0) {
            // } else {
            //     return true;
            // }
        });
    }

    /**
     * Form submission handling
     */
    $('#user_update_form').on('submit', function (e) {
        storeFormToStorage($('#user_update_form'), 'CloseWon');
        e.preventDefault();
        get_recaptcha_token('update_profile').then(function (token) {
            toggle_second_step();
            var data = $('#user_update_form').serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});
            data['unique_id'] = get_pm_tribe_me_id();
            data['recaptcha'] = token;
            $.ajax({
                url: $('#user_update_form').attr('action'),
                type: 'POST',
                data: data,
                beforeSend: function () {
                    $('.loader-holder').fadeIn(500)
                },
                complete: function () {
                    $('.loader-holder').fadeOut(500)
                },
                success: function (res) {
                    if (res.thank_you_url) {
                        window.location.href = res.thank_you_url;
                    } else {
                        printErrorMsg(res.error, 1);
                    }
                }
            });
        });
    });

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    function get_pm_tribe_me_id() {

        var key = localStorage.getItem("pm_tribe_me_id");
        if (key === null) {
            var newKey = uuidv4();
            localStorage.setItem('pm_tribe_me_id', newKey)
            return newKey;
        }
        return key;
    }

    function storeFormToStorage(form, stage) {
        var data = form.serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
        var pm_tribe_me_id = get_pm_tribe_me_id();
        localStorage.setItem('pm_tribe_data', JSON.stringify(data));
        if (window.location.host == 'addbiz.online' || window.location.host == 'staging.addbiz.online') {
            storeZohoRecord(form, stage);
        }
    }

    function loadFormFromStorage(form) {
        var images = ['logo_image', 'profile_pic_image', 'qr_code_image'];
        var ignored = ['design_template', 'form_step', '_token'];
        var pm_tribe_data = localStorage.getItem('pm_tribe_data');

        if (pm_tribe_data !== null) {

            var data = JSON.parse(pm_tribe_data);

            $.each(form.serializeArray(), function () {
                if (ignored.includes(this.name)) return;
                if (_.isEmpty(data[this.name])) return;
                if (this.name == 'domain_type') {
                    $("[name='" + this.name + "'][value='" + data[this.name] + "']").prop('checked', true).trigger('click');
                    //$("[name='" + this.name + "'][value='" + data[this.name] + "']").trigger("change");
                } else {
                    $("[name='" + this.name + "']").val(data[this.name]);
                }
                if (images.includes(this.name)) {
                    var preview = $("[name='" + this.name + "']").prevAll('.form__label_upload_image').find('img');
                    preview.attr('src', data[this.name])
                }


            });
        }

        form_loaded = true;
        loadProductsFromstorage(data);
        loadSocailLinksFromstorage(data);
        loadPaymentLinksFromstorage(data);
        loadServicesFromstorage(data);
        loadGalleryFromstorage(data);
    }

    function loadSocailLinksFromstorage(data) {
        if (data == undefined) return;
        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                if ($('#user_update_form').length) {
                    $('.delete-dynamic-social-link').trigger('click');
                }

                var dynamic_social_link_inputs = _.pickBy(data, (value, key) => _.includes(key, "dynamic_social_link_input"));
                var keys = _.keys(dynamic_social_link_inputs);

                var newKeys = keys.map(function (element) {
                    var s = _.split(element, '[', 2)[1];
                    var i = _.split(s, ']', 1)[0];
                    return i;
                });
                newKeys = _.uniq(newKeys);

                newKeys.forEach(element => {
                    var link = data['dynamic_social_link_input[' + element + '][link]'];
                    var platform = data['dynamic_social_link_input[' + element + '][platform]'];
                    $('#social_media_links_radio_' + platform).trigger('click');
                    $('#add_social_media_link_action').trigger('click');
                    $('.dynamic-social-link').find('input[type="hidden"][value="' + platform + '"]').next().val(link).trigger('change')
                });

                clearInterval(add_imageIcons);
            }

        }, 200)
    }

    function loadPaymentLinksFromstorage(data) {
        if (data == undefined) return;
        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                if ($('#user_update_form').length) {
                    $('.delete-dynamic-payment-link').trigger('click');
                }

                var dynamic_payment_link_inputs = _.pickBy(data, (value, key) => _.includes(key, "dynamic_payment_link_input"));
                var keys = _.keys(dynamic_payment_link_inputs);

                var newKeys = keys.map(function (element) {
                    var s = _.split(element, '[', 2)[1];
                    var i = _.split(s, ']', 1)[0];
                    return i;
                });
                newKeys = _.uniq(newKeys);

                newKeys.forEach(element => {
                    var link = data['dynamic_payment_link_input[' + element + '][link]'];
                    var platform = data['dynamic_payment_link_input[' + element + '][platform]'];
                    $('#payment_links_radio_' + platform).trigger('click');
                    $('#add_payment_link_action').trigger('click');
                    $('.dynamic-payment-link').find('input[type="hidden"][value="' + platform + '"]').next().val(link).trigger('change')
                });

                clearInterval(add_imageIcons);
            }

        }, 200)
    }

    function loadProductsFromstorage(data) {
        if (data == undefined) return;
        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                if ($('#user_update_form').length) {
                    $('.delete-dynamic-product').trigger('click');
                }

                var dynamic_social_link_inputs = _.pickBy(data, (value, key) => _.includes(key, "dynamic_products"));
                var keys = _.keys(dynamic_social_link_inputs);

                var newKeys = keys.map(function (element) {
                    var s = _.split(element, '[', 2)[1];
                    var i = _.split(s, ']', 1)[0];
                    return i;
                });
                newKeys = _.uniq(newKeys);

                newKeys.forEach(element => {
                    var name = data['dynamic_products[' + element + '][prod_name]'];
                    var price = data['dynamic_products[' + element + '][prod_price]'];
                    var img = data['dynamic_products[' + element + '][prod_image_hidden]'];


                    $('#add_new_product').trigger('click');
                    var elem = $('.dynamic-product').last();
                    elem.find('.prod_name_input').val(name).trigger('change');
                    elem.find('.prod_price_input').val(price).trigger('change');
                    if (img) {
                        elem.find('.prod_image_input_hidden').val(img).trigger('change');
                        elem.find('.form__label_upload_image').find('img').attr('src', img);
                    }

                });

                clearInterval(add_imageIcons);
            }

        }, 200)
    }

    function loadServicesFromstorage(data) {
        if (data == undefined) return;
        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                if ($('#user_update_form').length) {
                    $('.delete-dynamic-service').trigger('click');
                }

                var dynamic_social_link_inputs = _.pickBy(data, (value, key) => _.includes(key, "dynamic_services"));
                var keys = _.keys(dynamic_social_link_inputs);

                var newKeys = keys.map(function (element) {
                    var s = _.split(element, '[', 2)[1];
                    var i = _.split(s, ']', 1)[0];
                    return i;
                });
                newKeys = _.uniq(newKeys);

                newKeys.forEach(element => {

                    var name = data['dynamic_services[' + element + '][service_name]'];
                    var description = data['dynamic_services[' + element + '][service_description]'];
                    var img = data['dynamic_services[' + element + '][service_image_hidden]'];


                    $('#add_new_service').trigger('click');
                    var elem = $('.dynamic-service').last();
                    elem.find('.service_name_input').val(name).trigger('change');
                    elem.find('.service_description_input').val(description).trigger('change');
                    if (img) {
                        elem.find('.service_image_input_hidden').val(img).trigger('change');
                        elem.find('.form__label_upload_image').find('img').attr('src', img);
                    }

                });

                clearInterval(add_imageIcons);
            }

        }, 200)
    }

    function loadGalleryFromstorage(data) {
        if (data == undefined) return;
        var add_imageIcons = setInterval(function () {
            if (form_loaded) {

                if ($('#user_update_form').length) {
                    $('.delete-dynamic-gallery-item').trigger('click');
                }

                var dynamic_social_link_inputs = _.pickBy(data, (value, key) => _.includes(key, "dynamic_gallery"));
                var keys = _.keys(dynamic_social_link_inputs);

                var newKeys = keys.map(function (element) {
                    var s = _.split(element, '[', 2)[1];
                    var i = _.split(s, ']', 1)[0];
                    return i;
                });
                newKeys = _.uniq(newKeys);

                newKeys.forEach(element => {

                    var img = data['dynamic_gallery[' + element + '][gallery_item_image_hidden]'];


                    if (img) {
                        $('#add_new_gallery').trigger('click');
                        var elem = $('.dynamic-gallery-item').last();

                        elem.find('.gallery_item_image_input_hidden').val(img).trigger('change');
                        elem.find('.form__label_upload_image').find('img').attr('src', img);
                        $('#name').val($('#name').val() + ' ').trigger('change')
                        $('#name').val($('#name').val().trim()).trigger('change')
                    }

                });

                clearInterval(add_imageIcons);
            }

        }, 200)
    }

    function storeZohoRecord(form, status) {
        var images = ['logo_image', 'profile_pic_image', 'qr_code_image'];
        var data = form.serializeArray().reduce(function (obj, item) {
            if (!images.includes(item.name)) {
                obj[item.name] = item.value;
            }
            return obj;
        }, {});
        var pm_tribe_me_id = get_pm_tribe_me_id();

        data['unique_id'] = pm_tribe_me_id;
        data['status'] = status;
        try {

            $.ajax({
                url: zohoRecordStoreUrl,
                type: 'POST',
                data: data,
            });
        } catch (error) {
            console.log(error);
        }
    }

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return '';
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    if ($('#user_creation_form').length) {
        loadFormFromStorage($('#user_creation_form'));
        $('#user_creation_form').find('.form__input[required]').each(function () {
            $('.submit-btn').removeClass('active');
            if ($(this).val() == "") return false;
            $('.submit-btn').addClass('active');
        });
        $(document).on('blur change input', '.form__input', function () {
            if ($('#form_step').val() == '0') {
                storeFormToStorage($('#user_creation_form'), 'Initial');
            } else {
                if ($(this).attr('id') == 'page_name') {
                    $('.error-message').hide()
                    storeFormToStorage($('#user_creation_form'), 'PartialWithLink');
                }
            }
        });
        if ($('input[type="radio"][name="domain_type"]').length > 0) {
            $(document).on('change input[type="radio"][name="domain_type"]', function () {

                if ($('input[type="radio"][name="domain_type"]:checked').val() != 'free') {
                    if ($('#free_domain_container').hasClass("d-flex")) {
                        $('#free_domain_container').removeClass("d-flex")
                    }
                    if (!$('#free_domain_container').hasClass("d-none")) {
                        $('#free_domain_container').addClass("d-none");
                    }

                }
                if ($('input[type="radio"][name="domain_type"]:checked').val() == 'free') {
                    if (!$('#free_domain_container').hasClass("d-flex")) {
                        $('#free_domain_container').addClass("d-flex")
                    }
                    if ($('#free_domain_container').hasClass("d-none")) {
                        $('#free_domain_container').removeClass("d-none");
                    }

                }

                if ($('input[type="radio"][name="domain_type"]:checked').val() != 'pre_owened') {
                    if ($('#pre_owened_domain_container').hasClass("d-flex")) {
                        $('#pre_owened_domain_container').removeClass("d-flex")
                    }
                    if (!$('#pre_owened_domain_container').hasClass("d-none")) {
                        $('#pre_owened_domain_container').addClass("d-none");
                    }

                }
                if ($('input[type="radio"][name="domain_type"]:checked').val() == 'pre_owened') {
                    if (!$('#pre_owened_domain_container').hasClass("d-flex")) {
                        $('#pre_owened_domain_container').addClass("d-flex")
                    }
                    if ($('#pre_owened_domain_container').hasClass("d-none")) {
                        $('#pre_owened_domain_container').removeClass("d-none");
                    }

                }
            });
            $('input[type="radio"][name="domain_type"]:checked').trigger('change');
        }

    }

    if ($('#user_update_form').length) {
        var signature = getParameterByName('signature');
        var signatureFrom = localStorage.getItem('pm_signature');
        var clearStorage = false;
        if (signature != signatureFrom) {
            localStorage.setItem('pm_signature', signature);
            clearStorage = true;
        }
        var pm_tribe_design_template = localStorage.getItem('pm_tribe_design_template');
        if (clearStorage) {
            localStorage.removeItem('pm_tribe_me_id');
            localStorage.removeItem('pm_tribe_data');
            localStorage.removeItem('pm_tribe_design_template');
        }
        if (pm_tribe_design_template !== null) {
            var without_logo = ['3', '4'];
            $('#design_template').val(pm_tribe_design_template);
            if (without_logo.includes(pm_tribe_design_template)) {
                $('.logo_image_holder').remove()
            }
            fetch('/get_template_image/' + pm_tribe_design_template).then(function (res) {
                res.json().then(data => {
                    $('#selected_design_holder').find('img').attr('src', data.image)
                })
            });
        } else {
            var without_logo = ['3', '4'];
            $('#design_template').val();
            if (without_logo.includes($('#design_template').val())) {
                $('.logo_image_holder').remove()
            }
        }

        loadFormFromStorage($('#user_update_form'));
        $(document).on('blur change input', '.form__input', function () {
            storeFormToStorage($('#user_update_form'), 'CloseWon');
        });
    }

    /**
     *adding social links
     */

    var links_count = $('.dynamic-social-link').length;
    $(document).on('click', '#add_social_media_link_action', function (e) {
        e.preventDefault();
        var selected_social_media_link = $("input[name='social_media_links_radio']:checked").val();
        if (!selected_social_media_link) {
            alert('Please select a link');
            return false;
        } else {
            $("input[name='social_media_links_radio']:checked").parents('li').hide()
            $("input[name='social_media_links_radio']").prop('checked', false);
            links_count++;
            var base_url = asset_url + 'templates/images/common/'
            var dummy = $('.dummy-dynamic-social-link').clone();
            dummy.show();
            dummy.find('.icon img').attr('src', base_url + selected_social_media_link + '.svg');
            dummy.removeClass('dummy-dynamic-social-link');
            dummy.addClass('dynamic-social-link');
            dummy.find('.hidden').attr('name', 'dynamic_social_link_input[' + links_count + '][platform]');
            dummy.find('.hidden').val(selected_social_media_link);
            dummy.find('.form__input').attr('name', 'dynamic_social_link_input[' + links_count + '][link]');
            if (selected_social_media_link == 'whatsapp') {
                dummy.find('.form__label').text('Add Whats App Number (Optional)')
                dummy.find('.form__input').attr('placeholder', 'Type Country Code & Phone No');
                dummy.find('.field-info').removeClass('empty').html('e.g. - If Country Code 91 & Phone No 8888367888 Then type 918888367888')
            } else {
                dummy.find('.field-info').removeClass('empty').html('Copy & paste your profile links as it to avoid errors.')

            }
            $('.dynamic-social-links-holder').append(dummy);
            $('#add_socail_media_link_modal').modal('hide');
        }
    });

    $('#add_socail_media_link_modal').on('show.bs.modal', function () {
        // if ($('.dynamic-social-link').length == 5) {
        //     $('.social-media-links-add-holder').hide();
        //     $('.added-all-links').remove();
        //     $('.social-media-links-add-holder').after("<p class='added-all-links'>You can only add upto 5 social media links</p>")
        // } else {
        //     $('.social-media-links-add-holder').show();
        //     $('.added-all-links').remove()
        // }
    });

    $(document).on('click', '.delete-dynamic-social-link', function () {
        var platform = $(this).parents('.dynamic-social-link').find('input[type="hidden"]').val()
        $('.social-media-links-add-holder').find('input.social_media_links_radio[value="' + platform + '"]').parents('li').show()
        $(this).parents('.dynamic-social-link').remove();
        $('#name').val($('#name').val() + ' ').trigger('change')
        $('#name').val($('#name').val().trim()).trigger('change')

    });

    var links_count2 = $('.dynamic-payment-link').length;
    $(document).on('click', '#add_payment_link_action', function (e) {
        e.preventDefault();
        var selected_social_media_link = $("input[name='payment_links_radio']:checked").val();
        if (!selected_social_media_link) {
            alert('Please select a link');
            return false;
        } else {
            $("input[name='payment_links_radio']:checked").parents('li').hide()
            $("input[name='payment_links_radio']").prop('checked', false);
            links_count2++;
            var base_url = asset_url + 'templates/images/common/'
            var dummy = $('.dummy-dynamic-payment-link').clone();
            dummy.show();
            dummy.find('.icon img').attr('src', base_url + selected_social_media_link + '.svg');
            dummy.removeClass('dummy-dynamic-payment-link');
            dummy.addClass('dynamic-payment-link');
            dummy.find('.hidden').attr('name', 'dynamic_payment_link_input[' + links_count2 + '][platform]');
            dummy.find('.hidden').val(selected_social_media_link);
            dummy.find('.form__input').attr('name', 'dynamic_payment_link_input[' + links_count2 + '][link]');

            // dummy.find('.form__label').text('Add Whats App Number (Optional)')
            dummy.find('.form__input').attr('placeholder', 'Type Country Code & Phone No');
            // dummy.find('.field-info').removeClass('empty').html('e.g. - If Country Code 91 & Phone No 8888367888 Then type 918888367888')
            $('.dynamic-payment-links-holder').append(dummy);
            $('#add_payment_link_modal').modal('hide');
        }
    });


    $(document).on('click', '.delete-dynamic-payment-link', function () {
        var platform = $(this).parents('.dynamic-payment-link').find('input[type="hidden"]').val()
        $('.payment-links-add-holder').find('input.payment_links_radio[value="' + platform + '"]').parents('li').show()
        $(this).parents('.dynamic-payment-link').remove();
        $('#name').val($('#name').val() + ' ').trigger('change')
        $('#name').val($('#name').val().trim()).trigger('change')

    });
    var products_count = $('.dynamic-product').length;

    $(document).on('click', '#add_new_product', function () {
        var incompletedProd = true;
        var prod_msg = 'Please Fill all the product details';
        if (products_count == 0) {
            incompletedProd = false;
        } else {
            if ($('.dynamic-product').length == max_prod_count) {
                prod_msg = 'Only ' + max_prod_count + ' products allowed, if you want to increase limit please <a href="/feedback">contact us</a>';
                incompletedProd = true;
            } else {
                incompletedProd = $(".dynamic-product .prod_image_input_hidden, .dynamic-product  .form__input")
                    .filter(function () {
                        return $.trim($(this).val()).length == 0
                    }).length != 0;
            }
        }
        if (incompletedProd) {
            $.alert({
                title: 'Alert!',
                content: prod_msg,
            });
            // $(".dynamic-product  .form__input").each(function () {
            //     var element = $(this);
            //     if (element.val() == "") {
            //         element.addClass('invalid')
            //     }
            // });
            // $(".dynamic-product  .prod_image_input_hidden").each(function () {
            //     var element = $(this);
            //     if (element.val() == "") {
            //         element.parents('.dynamic-product').find('.form__label_upload_image').addClass('invalid');
            //     }
            // });
        } else {
            products_count++;
            var dummy = $('.dummy-dynamic-product').clone();
            dummy.show();
            dummy.removeClass('dummy-dynamic-product');
            dummy.addClass('dynamic-product');

            dummy.find('.prod_image_input')
                .attr('name', 'dynamic_products[' + products_count + '][prod_image]')
                .attr('id', 'dynamic_products_file_input_' + products_count);
            dummy.find('.prod_image_input_hidden')
                .attr('name', 'dynamic_products[' + products_count + '][prod_image_hidden]')
                .attr('id', 'dynamic_products_file_input_' + products_count + '_image');

            dummy.find('.form__label_upload_image').attr('for', 'dynamic_products_file_input_' + products_count)
            dummy.find('.prod_name_input').attr('name', 'dynamic_products[' + products_count + '][prod_name]');
            dummy.find('.prod_price_input').attr('name', 'dynamic_products[' + products_count + '][prod_price]');
            $('.dynamic-products-holder').append(dummy);
        }
    });

    $(document).on('click', '.delete-dynamic-product', function () {

        $(this).parents('.dynamic-product').remove();
        $('#name').val($('#name').val() + ' ').trigger('change')
        $('#name').val($('#name').val().trim()).trigger('change')

    });

    //gallery
    var gallery_items_count = $('.dynamic-gallery-item').length;

    $(document).on('click', '#add_new_gallery', function () {
        var incompletedGallery = true;
        var gallery_msg = 'Please Select Image';
        if (gallery_items_count == 0) {
            incompletedGallery = false;
        } else {
            if ($('.dynamic-gallery-item').length == max_gallery_count) {
                gallery_msg = 'Only ' + max_gallery_count + ' Images allowed, if you want to increase limit please <a href="/feedback">contact us</a>';
                incompletedGallery = true;
            } else {
                incompletedGallery = $(".dynamic-gallery-item .gallery_item_image_input_hidden")
                    .filter(function () {
                        return _.trim($(this).val()).length == 0
                    }).length != 0;
            }
        }
        if (incompletedGallery) {
            $.alert({
                title: 'Alert!',
                content: gallery_msg,
            });

        } else {
            gallery_items_count++;
            var dummy = $('.dummy-dynamic-gallery-item').clone();
            dummy.show();
            dummy.removeClass('dummy-dynamic-gallery-item');
            dummy.addClass('dynamic-gallery-item');

            dummy.find('.gallery_item_image_input')
                .attr('name', 'dynamic_gallery[' + gallery_items_count + '][gallery_item_image]')
                .attr('id', 'dynamic_gallery_file_input_' + gallery_items_count);
            dummy.find('.gallery_item_image_input_hidden')
                .attr('name', 'dynamic_gallery[' + gallery_items_count + '][gallery_item_image_hidden]')
                .attr('id', 'dynamic_gallery_file_input_' + gallery_items_count + '_image');

            dummy.find('.form__label_upload_image').attr('for', 'dynamic_gallery_file_input_' + gallery_items_count)

            $('.dynamic-gallery-holder').append(dummy);
        }
    });

    $(document).on('click', '.delete-dynamic-gallery-item', function () {

        $(this).parents('.dynamic-gallery-item').remove();
        $('#name').val($('#name').val() + ' ').trigger('change')
        $('#name').val($('#name').val().trim()).trigger('change')

    });

    //Code for Services
    var services_count = $('.dynamic-service').length;

    $(document).on('click', '#add_new_service', function () {
        var incompletedService = true;
        var service_msg = 'Please Fill all the service details';
        if (services_count == 0) {
            incompletedService = false;
        } else {
            if ($('.dynamic-service').length == max_service_count) {
                service_msg = 'Only ' + max_service_count + ' services allowed, if you want to increase limit please <a href="/feedback">contact us</a>';
                incompletedService = true;
            } else {
                incompletedService = $(".dynamic-service .service_image_input_hidden, .dynamic-service  .form__input")
                    .filter(function () {
                        return $.trim($(this).val()).length == 0
                    }).length != 0;
            }
        }
        if (incompletedService) {
            $.alert({
                title: 'Alert!',
                content: service_msg,
            });

        } else {
            services_count++;
            var dummy = $('.dummy-dynamic-service').clone();
            dummy.show();
            dummy.removeClass('dummy-dynamic-service');
            dummy.addClass('dynamic-service');

            dummy.find('.service_image_input')
                .attr('name', 'dynamic_services[' + services_count + '][service_image]')
                .attr('id', 'dynamic_services_file_input_' + services_count);
            dummy.find('.service_image_input_hidden')
                .attr('name', 'dynamic_services[' + services_count + '][service_image_hidden]')
                .attr('id', 'dynamic_services_file_input_' + services_count + '_image');

            dummy.find('.form__label_upload_image').attr('for', 'dynamic_services_file_input_' + services_count)
            dummy.find('.service_name_input').attr('name', 'dynamic_services[' + services_count + '][service_name]');
            dummy.find('.service_description_input').attr('name', 'dynamic_services[' + services_count + '][service_description]');
            $('.dynamic-services-holder').append(dummy);
        }
    });

    $(document).on('click', '.delete-dynamic-service', function () {

        $(this).parents('.dynamic-service').remove();
        $('#name').val($('#name').val() + ' ').trigger('change')
        $('#name').val($('#name').val().trim()).trigger('change')

    });

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    var UTMPARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];


    function pm_set_cookie(item, index) {
        var value = getParameterByName(item);
        if (value !== "") {
            setCookie(item, value, 365);
        }
    }

    UTMPARAMS.forEach(pm_set_cookie);

})();
